import { render } from "./StepTreatComponent.vue?vue&type=template&id=d8a43c58"
import script from "./StepTreatComponent.vue?vue&type=script&lang=js"
export * from "./StepTreatComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__